module.exports = __webpack_public_path__ + "mainassets/img/footerACGlogo.c2672ba3.svg";